import React, { useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { Link, useNavigate } from "react-router-dom";
import { Styles } from "./styles";
import FooterLogo from "../../Assets/Svg/Footer-logo.svg";
import Telegram from "../../Assets/Svg/Telegram.svg";
import Twitter from "../../Assets/Svg/Twitter.svg";
import Youtube from "../../Assets/Svg/youtube.svg";
import Instaram from "../../Assets/Svg/instagram.svg";
import Facebook from "../../Assets/Svg/Facebook.svg";
import Crypto from "../../Assets/crypto.png";
import Payeer from "../../Assets/Payeer.png";
import { Helper } from "../../tools/Helper";
import { api_Routes } from "../../api_Routes";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Footer = () => {
    const navigate = useNavigate();
    const [settings, setSettings] = useState({
        location: "",
        contactemail: "",
        contactphonenumber: "",
    });
    const [showLinks, setShowLinks] = useState(false);
    const [notification, setNotification] = useState({
        open: false,
        message: "",
        severity: "success",
    });
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const wrapperRef = useRef(null);

    // Check authentication status
    useEffect(() => {
        const token = localStorage.getItem("user"); // Replace with your actual token check
        setIsLoggedIn(!!token);
    }, []);

    // Handle clicks outside the component
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setShowLinks(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    // Load settings data
    useEffect(() => {
        const getData = async () => {
            const { response } = await Helper.Get({
                url: `${api_Routes.Settings.View}`,
                hasToken: true,
            });
            if (response) {
                setSettings({
                    location: response.message?.result?.location || "",
                    contactemail: response.message?.result?.contactemail || "",
                    contactphonenumber:
                        response.message?.result?.contactphonenumber || "",
                });
            }
        };
        getData();
    }, []);

    const handleCloseNotification = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setNotification({ ...notification, open: false });
    };

    const handleSubscribe = async () => {
        if (!isLoggedIn) {
            navigate("/login");
            return;
        }

        try {
            const { response, error } = await Helper.Post({
                url: `${api_Routes.Auth.subscribeEmail}`,
                hasToken: true,
            });

            if (response) {
                setNotification({
                    open: true,
                    message: "You've been subscribed successfully!",
                    severity: "success",
                });
            } else if (error) {
                setNotification({
                    open: true,
                    message: error.message || "Subscription failed. Please try again.",
                    severity: "error",
                });
            }
        } catch (err) {
            setNotification({
                open: true,
                message: "An error occurred during subscription",
                severity: "error",
            });
        }
    };

    return (
        <Styles>
            <Box className="footer" sx={{ padding: { xs: "40px", sm: "40px 80px" } }}>
                <Grid
                    container
                    spacing={4}
                    sx={{
                        flexDirection: { xs: "column", md: "row" },
                        alignItems: { xs: "center", md: "normal" },
                    }}
                >
                    {/* First Column */}
                    <Grid item xs={12} md={4}>
                        <Box>
                            <Box sx={{ display: "flex", justifyContent: { xs: "center", md: "start" } }}>
                                <img src={FooterLogo} alt="Footer Logo" />
                            </Box>
                            <Typography className="footer-description">
                                Unlock the full potential of your online presence with our
                                tailored social media panel services.
                            </Typography>
                            <Box sx={{ marginTop: 5 }}>
                                <Button
                                    variant="contained"
                                    sx={{
                                        backgroundColor: "#3F78E0",
                                        color: "#F1F5FD",
                                        borderRadius: "12px",
                                        "&:hover": { backgroundColor: "#355dab" },
                                        border: "2px solid #3F78E0",
                                        display: "flex",
                                        gap: "10px",
                                        padding: "10px 12px",
                                        boxShadow: "0px 4px 4px #00000040",
                                    }}
                                    onClick={() => navigate("/signup")}
                                >
                                    <Typography
                                        sx={{
                                            textTransform: "capitalize",
                                            fontWeight: "500",
                                            fontSize: "16px",
                                            color: "#F1F5FD",
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        Sign up
                                    </Typography>
                                    <svg
                                        className="sign-up-arrow"
                                        width="17"
                                        height="17"
                                        viewBox="0 0 17 17"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M11.2441 2.8457H14.0653C14.4394 2.8457 14.7982 2.99432 15.0627 3.25885C15.3273 3.52339 15.4759 3.88218 15.4759 4.25629V14.1304C15.4759 14.5045 15.3273 14.8633 15.0627 15.1278C14.7982 15.3924 14.4394 15.541 14.0653 15.541H11.2441"
                                            stroke="white"
                                            strokeWidth="1.41059"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M7.7168 12.7199L11.2433 9.19346L7.7168 5.66699"
                                            stroke="white"
                                            strokeWidth="1.41059"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                        <path
                                            d="M11.2428 9.19336H2.7793"
                                            stroke="white"
                                            strokeWidth="1.41059"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        />
                                    </svg>
                                </Button>
                            </Box>
                        </Box>
                    </Grid>

                    {/* Second Column */}
                    <Grid item xs={12} md={2.5} style={{ placeItems: "center" }}>
                        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <Typography className="footer-title" textAlign="center">
                                Location & Contact
                            </Typography>
                            <Typography className="footer-contact" textAlign="center">
                                <span>{settings.location}</span>
                                <span>{settings.contactemail}</span>
                                <span>{settings.contactphonenumber}</span>
                            </Typography>
                        </Box>
                    </Grid>

                    {/* Third Column */}
                    <Grid item xs={12} md={1.8} style={{ placeItems: "center" }}>
                        <Typography className="footer-title">Links</Typography>
                        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <Link className="footerroute" to="/home">
                                Services Finder
                            </Link>
                            <Link className="footerroute" to="/OurServices">
                                Our Services
                            </Link>
                            <Link className="footerroute" to="/AddPanel">
                                Add Panel
                            </Link>
                        </Box>
                    </Grid>

                    {/* Fourth Column */}
                    <Grid item xs={12} md={1.8} style={{ placeItems: "center" }}>
                        <Typography className="footer-title">More Links</Typography>
                        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <Link className="footerroute" to="/Team">
                                Our Team
                            </Link>
                            <Link className="footerroute" to="/FAQ">
                                FAQ
                            </Link>
                            <Link className="footerroute" to="/About">
                                About Us
                            </Link>
                            <Link className="footerroute" to="/Terms">
                                Terms
                            </Link>
                        </Box>
                    </Grid>

                    {/* Fifth Column - Subscribe */}
                    <Grid item xs={12} md={1.9} style={{ placeItems: "center" }}>
                        <Typography className="footer-title">Subscribe</Typography>
                        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <Typography sx={{ textAlign: "center", fontSize: "14px" }}>
                                Get our latest offers and news
                            </Typography>
                            <Button
                                sx={{
                                    color: "#3F78E0",
                                    border: "solid 2px #3F78E0",
                                    width: "110px",
                                    borderRadius: "8px",
                                    fontSize: "15px",
                                    lineHeight: "20px",
                                    fontWeight: "500",
                                    boxShadow: `
                    -2px 4px 4px #00000040,
                    inset 0px 5px 10px #FFFFFF40
                  `,
                                    background: "white",
                                    marginTop: "10px",
                                    "&:hover": {
                                        backgroundColor: "#f0f4fa",
                                    },
                                }}
                                onClick={handleSubscribe}
                            >
                                Subscribe
                            </Button>
                        </Box>
                    </Grid>
                </Grid>

                {/* Bottom Row */}
                <Grid
                    container
                    spacing={4}
                    sx={{
                        flexDirection: { xs: "column-reverse", md: "row" },
                        alignItems: { xs: "center", md: "normal" },
                        marginTop: "20px",
                    }}
                >
                    <Grid
                        item
                        xs={12}
                        md={5}
                        sx={{
                            display: "flex",
                            flexDirection: { xs: "column", sm: "row" },
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "20px",
                        }}
                    >
                        <Typography sx={{ fontSize: "14px" }}>
                            © 2022 BookSMM. All rights reserved
                        </Typography>
                        <Link
                            className="footerroute"
                            to="/PrivacyPolicy"
                            style={{ margin: "0", padding: "0", fontSize: "14px" }}
                        >
                            Privacy Policy
                        </Link>
                        <Link
                            className="footerroute"
                            to="/Terms"
                            style={{ margin: "0", padding: "0", fontSize: "14px" }}
                        >
                            Term of use
                        </Link>
                    </Grid>

                    <Grid
                        item
                        xs={12}
                        md={3}
                        sx={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            gap: "20px",
                        }}
                    >
                        <Typography>Payments</Typography>
                        <img src={Crypto} alt="crypto" />
                        <img src={Payeer} alt="Payeer" />
                    </Grid>

                    <Grid
                        item
                        xs={12}
                        md={4}
                        sx={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "50px",
                            alignItems: "center",
                            flexWrap: "wrap",
                        }}
                    >
                        {/* Social media icons... */}
                    </Grid>
                </Grid>
            </Box>

            {/* Notification Snackbar */}
            <Snackbar
                open={notification.open}
                autoHideDuration={6000}
                onClose={handleCloseNotification}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
                <Alert
                    onClose={handleCloseNotification}
                    severity={notification.severity}
                    sx={{ width: "100%" }}
                >
                    {notification.message}
                </Alert>
            </Snackbar>
        </Styles>
    );
};

export default Footer;